import React from "react";

export default function RSVPManagement() {
  return (
    <section id="RSVPManagement" className="pc-section papercraft">
      <header className="pc-section__head">
        <span className="pc-eyebrow">A clear view of your guests</span>
        <h2 className="pc-section__title">
          Guest list <em style={{ fontStyle: "italic", color: "var(--pc-terracotta)" }}>management</em>.
        </h2>
        <p className="pc-section__lede">
          Purpose-built tools keep your online guest list organized, current,
          and quietly working — so you can focus on the gathering, not the spreadsheet.
        </p>
      </header>

      <div className="pc-frame pc-rsvp-image">
        <img src={require("./Logos/RSVPImage.png")} alt="Guest list dashboard" />
      </div>
    </section>
  );
}
